import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { isDeliveryEnabled } from '@web/core/helpers/is-delivery-enabled.helper';
import { CONFIG } from '@web/core/injection-tokens/config.token';

export const canMatchProjects: CanMatchFn = () => isDeliveryEnabled(inject(CONFIG));
